export enum CompetitionCategoryEnum {
  Invalid = 0,  
  Project = 1,
  Person = 2
}
  